/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import { useTranslation } from "react-i18next";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
//custom libraries
import Paper from "../components/paper";

interface OrganizationInformationSectionProps {
  address: any;
}

const OrganizationInformationSection: React.FC<OrganizationInformationSectionProps> = (
  props: any
) => {
  const { t } = useTranslation();

  const { address } = props;

  return (
    <Paper>
      <Grid container direction="column" spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h2">
            {t("Organization.OrganizationInformation")}
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body2">
            {t("Organization.OrganizationName")}
          </Typography>
          <Typography variant="body1">{address?.nickName}</Typography>
        </Grid>
        <Grid item>
          <Divider />
        </Grid>
        <Grid item>
          <Typography variant="h3">{t("Customer.ContactDetails")}</Typography>
        </Grid>
        <Grid item>
          <Typography variant="body2">{t("Customer.PhoneNumber")}</Typography>
          <Typography variant="body1">{address?.phone1}</Typography>
        </Grid>
        <Grid item>
          <Typography variant="body2">{t("Customer.Email")}</Typography>
          <Typography variant="body1">{address?.email1}</Typography>
        </Grid>
        <Grid item>
          <Divider />
        </Grid>
        <Grid item>
          <Typography variant="h3">{t("Customer.AddressDetails")}</Typography>
        </Grid>
        <Grid item container spacing={2} direction="row">
          <Grid item xs={6} sm={5} md={4} lg={3} xl={2}>
            <Typography variant="body2">
              {t("Customer.StreetAddress")}
            </Typography>
            <Typography variant="body1">{address?.address1}</Typography>
          </Grid>
          <Grid item xs={6} sm={5} md={4} lg={3} xl={2}>
            <Typography variant="body2">{t("Customer.ZipCode")}</Typography>
            <Typography variant="body1">{address?.zipCode}</Typography>
          </Grid>
        </Grid>
        <Grid item container spacing={2} direction="row">
          <Grid item xs={6} sm={5} md={4} lg={3} xl={2}>
            <Typography variant="body2">{t("Customer.State")}</Typography>
            <Typography variant="body1">{address?.state}</Typography>
          </Grid>
          <Grid item xs={6} sm={5} md={4} lg={3} xl={2}>
            <Typography variant="body2">{t("Customer.Country")}</Typography>
            <Typography variant="body1">{address?.country}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default OrganizationInformationSection;
